import { Title } from '../List';
import styled from 'styled-components';

export const PaddedTitle = styled(Title)`
  padding-top: ${({ theme }) => theme.spacing.base.xs};
`;
